export default "__VITE_ASSET__tUNFgDTN__"